module.exports = __webpack_public_path__ + "static/img/wb_qr20240213.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/coder1.png
// module id = rMEk
// module chunks = 0